<template>
  <div>
    <div class="lds-facebook"  v-if="!loading"><div></div><div></div><div></div></div>
     <div>
        <a-button type="default" size="small" @click="goBack" style="margin-left:10px"><span class="ti-arrow-left"></span></a-button>
        <a-row v-if="loading">
            <a-col :span="8"  style="padding: 10px;">
                <App :addNewUser="addNewUser"/>
            </a-col>
            <a-col :span="8" style="padding: 10px;">
                <Institution 
                    :application="application" 
                    :addNewInstitutionHost="addNewInstitutionHost" 
                    :addNewInstitution="addNewInstitution" 
                    :deleteInstitution="deleteInstitution"
                    :showModal="showModal"
                    :handleCancel="handleCancel"
                />
            </a-col>
            <a-col :span="8"  style="padding: 10px;">
              <Rooms :application="application" 
              :addNewHost="addNewHost"
              :deleteHost="deleteHost"
              :RemoveHost="RemoveHost"
              />
            </a-col>
        </a-row>
        <a-modal
            :footer="null"
            width="800px"
            :title="modal_title"
            :visible="visible"
            :confirm-loading="confirmLoading"
            @cancel="handleCancel"
            >
            <a-row :gutter="16"  v-if="detailsareset">
                <a-col :span="12">
                    <a-card title="Institution users" :bordered="false">
                        <table class="table table-hover" v-if="institution.users.length">
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                            </tr>
                            <tr v-for="(item,i) in institution.users" :key="i">
                                <td>{{item.name}}</td>
                                <td>{{item.email}}</td>
                            </tr>
                        </table>
                        <a-empty v-else>  <span slot="description">Empty! </span></a-empty>
                    </a-card>
                </a-col>
                <a-col :span="12">
                    <a-card title="Institution hosts" :bordered="false">
                        <table class="table table-hover" v-if="institution.hosts.length">
                            <tr>
                                <th>Email</th>
                            </tr>
                            <tr v-for="(item,i) in institution.hosts" :key="i">
                                <td>{{item.host_email}}</td>
                            </tr>
                        </table>
                        <a-empty v-else>  <span slot="description">Empty! </span></a-empty>
                    </a-card>
                </a-col>
            </a-row>
        </a-modal>
        <a-modal
            :footer="null"
            :title="actiontitle"
            :visible="visible_actions"
            @cancel="handleCancelAction"
            >
            <a-row :gutter="24">
                <div v-if="isaddeduser">
                    <a-form :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" @submit="handleSubmit">
                        <a-form-item label="Emri">
                            <a-input
                                v-decorator="['name', { rules: [{ required: true, message: 'Please insert user name!' }] }]"
                            />
                        </a-form-item>
                        <a-form-item label="Email">
                            <a-input type="email"
                                v-decorator="['email', { rules: [{ required: true, message: 'Please insert email!' }] }]"
                            />
                        </a-form-item>
                        <a-form-item label="Password">
                            <a-input type="password"
                                v-decorator="['password', { rules: [{ required: true, message: 'Please insert password!' }] }]"
                            />
                        </a-form-item>
                        <a-form-item label="User type">
                            <a-select
                                v-decorator="[
                                'user_type',
                                { rules: [{ required: true, message: 'Please select user type!' }] },
                                ]"
                                @change="handleSelectChange"
                            >
                                <a-select-option value="1">
                                    Application User
                                </a-select-option>
                                <a-select-option value="2">
                                    Personal User
                                </a-select-option>
                                <a-select-option value="3" v-if="application.institutions.length">
                                Institution User
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        
                        <div v-if="selectedinstitution">
                            <a-form-item label="Institutions">
                                <a-select
                                    v-decorator="[
                                    'institution_id',
                                    { rules: [{ required: true, message: 'Please select Institution!' }] },
                                    ]"
                                    @change="handleSelectChangeInstitution"
                                >
                                    <a-select-option v-for="item in application.institutions" :value="item.ew_ins_id" :key="item.ew_ins_id">
                                    {{item.ew_ins_name}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </div>
                        <div v-if="selectedpersonal">
                            <a-form-item label="Zoom Key">
                                <a-input
                                    v-decorator="['zoom_key', { rules: [{ required: true, message: 'Please insert zoom key!' }] }]"
                                />
                            </a-form-item>
                            <a-form-item label="Zoom secret">
                                <a-input
                                    v-decorator="['zoom_secret', { rules: [{ required: true, message: 'Please insert zoom secret!' }] }]"
                                />
                            </a-form-item>
                        </div>
                        <a-form-item :wrapper-col="{ span: 4, offset: 4 }">
                            <a-button type="primary" html-type="submit">
                                Submit
                            </a-button>
                        </a-form-item>
                    </a-form>
                </div>
                <div v-if="isaddedinstitution">
                    <a-form :form="form_inst" :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }" @submit="handleSubmitIns">
                        <a-form-item label="Institution name">
                            <a-input v-decorator="['institution_name', { rules: [{ required: true, message: 'Please insert istitution name!' }] }]"/>
                        </a-form-item>
                        <a-form-item label="Application">
                            <b>{{application.ew_app_name}}</b>
                        </a-form-item>
                        <a-form-item :wrapper-col="{ span: 4, offset: 4 }">
                            <a-button type="primary" html-type="submit">
                                Submit
                            </a-button>
                        </a-form-item>
                    </a-form>
                </div>
                <div v-if="isaddedhost">
                    <a-form :form="form_host" :label-col="{ span: 6}" :wrapper-col="{ span: 16 }" @submit="handleSubmitHost">
                        <a-form-item label="Inactive Rooms">
                            <a-select
                                v-decorator="[
                                'room_id',
                                { rules: [{ required: true, message: 'Please select room!' }] },
                                ]"
                                @change="handleSelectRooms"
                            >
                                <a-select-option v-for="item in application.inactive_hosts" :value="item.room_id" :key="item.room_id" >
                                    {{item.room_name}}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                         <a-form-item label="Application">
                            <b>{{application.ew_app_name}}</b>
                        </a-form-item>
                        <a-form-item :wrapper-col="{ span: 4, offset: 4 }">
                            <a-button type="primary" html-type="submit">
                                Submit
                            </a-button>
                        </a-form-item>
                    </a-form>
                </div>
                 <div v-if="isaddedinstitutionhost">
                    <a-form :form="form_institution_host" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" @submit="handleSubmitInstitutionHost">
                        <a-form-item label="User type">
                            <a-select
                                v-decorator="[
                                'existing_host',
                                { rules: [{ required: true, message: 'Please select user type!' }] },
                                ]"
                                @change="handleSelectChangeInstitutionHost"
                            >
                                <a-select-option value="1">
                                   Existing hosts
                                </a-select-option>
                                <a-select-option value="2">
                                   New host
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                        
                        <div v-if="isexisthost">
                            <a-form-item label="Hosts">
                                <a-select v-decorator="['host_id',{ rules: [{ required: true, message: 'Please select host!' }] },]" >
                                    <a-select-option v-for="item in application.hosts" :value="item.host_id" :key="item.host_id">
                                    {{item.email}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </div>
                        <div v-if="isnewhost">
                            <a-form-item label="Email">
                                <a-input type="email"
                                    v-decorator="['email', { rules: [{ required: true, message: 'Please insert email!' }] }]"
                                />
                            </a-form-item>
                            <a-form-item label="Zoom Key">
                                <a-input
                                    v-decorator="['zoom_key', { rules: [{ required: true, message: 'Please insert zoom key!' }] }]"
                                />
                            </a-form-item>
                            <a-form-item label="Zoom secret">
                                <a-input
                                    v-decorator="['zoom_secret', { rules: [{ required: true, message: 'Please insert zoom secret!' }] }]"
                                />
                            </a-form-item>
                        </div>
                        <a-form-item :wrapper-col="{ span: 4, offset: 4 }">
                            <a-button type="primary" html-type="submit">
                                Submit
                            </a-button>
                        </a-form-item>
                    </a-form>
                </div>
            </a-row>
        </a-modal>
    </div>
  </div>
</template>
<script>

import API from '../../services/api';
import  { 
    addNewUser,
    addNewInstitution,
    addNewHost,
    addNewInstitutionHost,
    handleSubmit,
    handleSubmitIns,
    handleSubmitHost,
    handleSubmitInstitutionHost,
    resetForm,
    handleSelectChange,
    handleSelectChangeInstitutionHost,
    getApplications,
    showModal,
    getInstitution,
    handleCancel,
    handleCancelAction,
    deleteInstitution,
    cancel,
    deleteUser,
    deleteHost,
    RemoveHost,
    data
} from './modules/applications'
import App from './components/App.vue'
import Institution from './components/Institution.vue'
import Rooms from './components/Rooms.vue'
export default {
    components:{App,Institution,Rooms},
    data,
    computed: {
        userLogin() {
        return this.$store.state.auth.user;
        }
    },
    created(){
        this.getApplications();
    },
    methods: {
        goBack(){
        return this.$router.go(-1)
        },
        addNewUser,
        addNewInstitution,
        addNewHost,
        addNewInstitutionHost,
        handleSubmit,
        handleSubmitIns,
        handleSubmitHost,
        handleSubmitInstitutionHost,
        resetForm,
        handleSelectChange,
        handleSelectChangeInstitutionHost,
        getApplications,
        showModal,
        getInstitution,
        handleCancel,
        handleCancelAction,
        deleteInstitution,
        deleteUser,
        deleteHost,
        RemoveHost,
        cancel
    }
};
</script>
<style>
</style>
